 export const TAB_LIST = [
        {
            key: "1",
            label: "Active",
        },
        {
            key: "2",
            label: "Inactive",
        },
    ];

export const TEMPLATE_FILES = {
    csv: "/templates/user_template.csv",
    txt: "/templates/user_template.txt",
    xlsx: "/templates/user_template.xlsx",
};

export const BULK_UPLOAD_FORMAT_OPTIONS = [
    { value: "csv", label: "CSV Template" },
    { value: "txt", label: "TXT Template" },
    { value: "xlsx", label: "XLSX Template" },
];